<template>
    <div>
        <v-data-table v-model="selectedItems" :headers="headers" :items="items" :items-per-page="10"
            :options.sync="options" :server-items-length="totalItems" item-key="id" show-select :loading="isLoading"
            :loading-text="$t('loadingPleaseWait')" :no-data-text="$t('noData')" :footer-props="footerProps"
            :header-props="headerProps">
            <template v-slot:item.existence="{ item }">
                <control-existence :control-data="item" @update="updateItem"></control-existence>
            </template>

            <template v-slot:item.price="props">
                <v-edit-dialog :return-value.sync="props.item.price" large persistent :cancel-text="$t('cancel')"
                    :save-text="$t('change')" color="orange lighten-2" transition="slide-y-transition"
                    @save="updateParam({ param: 'price', value: props.item.price, productId: props.item.id })">
                    <div class="text-decorated-underline">{{ props.item.price }}</div>
                    <template v-slot:input>
                        <v-text-field v-model="props.item.price" :label="$t('price')" counter autofocus></v-text-field>
                    </template>
                </v-edit-dialog>
            </template>

            <template v-slot:item.currency="props">
                <v-edit-dialog :return-value.sync="props.item.currency" large persistent :cancel-text="$t('cancel')"
                    :save-text="$t('change')" color="orange lighten-2" transition="slide-y-transition"
                    @save="updateCurrency({ param: 'currency', price: props.item.price, value: props.item.currency, product: props.item })">
                    <div class="text-decorated-underline">{{ props.item.currency }}</div>
                    <template v-slot:input>
                        <v-select v-model="props.item.currency" :label="$t('currency')" :items="currencies"></v-select>
                    </template>
                </v-edit-dialog>
            </template>

            <template v-slot:item.withNds="{ item: { id, withNds } }">
                <v-switch class="pl-5" color="teal" v-model="withNds"
                    @change="updateParam({ param: 'nds', productId: id, value: $event })"></v-switch>
            </template>

            <template v-slot:item.visibility="{ item: { id, visibility } }" v-if="pageType === 'all'">
                <v-switch class="pl-5" color="teal" v-model="visibility"
                    @change="updateParam({ param: 'visibility', productId: id, value: $event })"></v-switch>
            </template>
            <template v-slot:item.visibility="{ item: { id, visibility } }" v-else>
                <v-btn color="teal" fab x-small @click="updateParam({ param: 'visibility', productId: id, value: true })"
                    dark>
                    <v-icon>mdi-check</v-icon>
                </v-btn>
            </template>

            <template v-slot:item.pack="{ item }">
                <pack v-if="item.pack" :pack="item.pack"></pack>
            </template>

            <template v-slot:item.action="{ item }">
                <table-actions :item="item" @set-items="setItems"></table-actions>
            </template>

        </v-data-table>
    </div>
</template>

<script>

import ControlExistence from "./ControlExistence";
import ControlCurrency from "./ControlCurrency";
import Pack from "./Pack"
import TableActions from "./TableActions";
import { MixinAppSnack, MixinTableLoadState } from "../../../mixins";
import { ProductsService } from "../../../services";

export default {
    name: "Products",
    props: ['filters', 'pageType'],
    mixins: [MixinAppSnack, MixinTableLoadState],
    components: {
        ControlExistence,
        ControlCurrency,
        Pack,
        TableActions,
    },
    data() {
        return {
            headers: [],
            items: [],
            options: {},
            totalItems: null,
            footerProps: {
                'items-per-page-text': this.$t('rowsPerPage'),
                'items-per-page-all-text': this.$t('all'),
            },
            headerProps: {
                sortByText: this.$t('sortBy'),
            }
        }
    },
    computed: {
        selectedItems: {
            get() {
                return this.$store.getters.selectedProducts;
            },
            set(newVal) {
                this.$store.commit('setSelectedProducts', newVal);
            }
        },
        currencies() {
            return this.$store.getters.currencies.map(item => item.name.toUpperCase());
        },
    },
    methods: {
        multipleDeleting() {
            const IDs = this.selectedItems.map(item => item.id);
            ProductsService.setAuth(this.$store.getters.token);
            ProductsService.deleteMultiple(IDs)
                .then(res => {
                    console.log(res.data);
                    this.setItems();
                })
                .catch(err => {
                    console.log(err);
                })
        },
        setItems() {
            if (!this.startTableLoading()) return false;

            const params = {
                ...this.options,
                pageType: this.pageType,
                filters: this.filters
            };

            ProductsService.setAuth(this.$store.getters.token);
            ProductsService.getProducts(params)
                .then(res => {
                    this.items = res.data.data;
                    this.totalItems = res.data.total;
                })
                .catch(err => {
                    this.emitTableLoadError(err);
                })
                .finally(() => {
                    this.stopTableLoading();
                });
        },
        setTable() {
            ProductsService.setAuth(this.$store.getters.token);
            ProductsService.getTableData()
                .then(res => {
                    this.headers = res.data.headers;
                })
                .catch(err => {
                    this.emitTableLoadError(err);
                })
        },
        updateCurrency(data) {
            const params = {
                productId: data.product.id,
                value: data.value,
                price: data.price
            };

            ProductsService.updateParam(data.param, params)
                .then(res => {
                    this.resetSnack();
                    this.setSuccessSnack();
                    this.setSnackText(this.$t('dataSuccessUpdated'));
                    this.openSnack();
                })
                .catch(err => {
                    this.resetSnack();
                    this.setDeleteSnack();
                    this.setSnackText(this.$t('dataErrorUpdated'));
                    this.openSnack();
                });
        },
        updateItem(data) {
            if (!data || !data.id) return false;

            const idx = this.items.findIndex(item => item.id === data.id);

            if (idx > - 1) {
                this.items[idx] = data;
            }
        },
        updateParam({ param, ...data }) {
            ProductsService.setAuth(this.$store.getters.token);
            ProductsService.updateParam(param, data)
                .then(() => {
                    this.resetSnack();
                    this.setSuccessSnack();
                    this.setSnackText(this.$t('dataSuccessUpdated'));
                    this.openSnack();
                    this.setItems();
                })
                .catch(err => {
                    console.log(err);
                    this.resetSnack();
                    this.setDeleteSnack();
                    this.setSnackText(this.$t('dataErrorUpdated'));
                    this.openSnack();
                });
        },
    },
    created() {
        this.setTable();
    },
    watch: {
        filters: {
            handler() {
                this.setItems();
            },
            deep: true
        },
        options: {
            handler() {
                this.setItems();
            },
            deep: true
        },
    }
}
</script>

<style scoped></style>
